export interface DropdownOption {
	value: string | number;
	label: string;
}

/** Map API dropdown items to `{ value, label }` options. */
export function mapDropdownOptions(raw: unknown): DropdownOption[] {
	if (raw === undefined || Array.isArray(raw) === false) {
		return [];
	}

	return (raw as Array<{ value?: string | number; label?: string }>).map((item) => ({
		value: item.value ?? "",
		label: item.label ?? "",
	}));
}
